'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /Users/spikelny/Desktop/projects/art/fastcash/~/react/react.js
 ** module id = 206
 ** module chunks = 0
 **/